<!-- <app-data-table [columns]="cols" [data]="systems" [title]="title"></app-data-table> -->


<ng-container>
    <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()" [url]="'/master/rop/'"
        [isDeletable]="'/master/rop' | hasPermission: 'Delete'" [showAddButton]="'/master/rop' | hasPermission: 'Add'"
        [showActions]="canEditSetup" [isEditable]="'/master/rop' | hasPermission: 'Edit'" [title]="title"
        (onAdd)="addSystem()" (editEventRow)="updateSystem($event)" [isView]="'/master/rop' | hasPermission: 'View'"
        (viewEventRow)="viewSystem($event)" (deleteEventRow)="showDeletePopup($event)"
        (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
    </app-data-table>
</ng-container>

<!-- Reusable Dialog for Add/Edit/View -->
<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="dialogConfig"
  [initialData]="initialData"
  [viewMode]="viewMode"
  (onSubmit)="onDialogSubmit($event)"
  (onCancel)="onDialogCancel()"
  (onClose)="onDialogClose()">
</app-reusable-dialog>



<p-dialog header="Delete Class" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }"
    [maximizable]="true">
    <div class="delete-dialog mt-3">
        <i class="pi pi-trash text-danger custom-delete-icon"></i>
        <span>Are you sure , you want to delete class ?</span>
        <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()"
            class="mt-2">
        </p-button>
    </div>
</p-dialog>